export default __webpack_public_path__ + "static/media/whatsapp_green_404.82b10ec6.svg";